import { AbstractModel } from '@/models/abstractModel';
import type { ITeamPageApi } from '@/types/team';

export class TeamItem extends AbstractModel {
    public bookmakerId: number = 0;
    public createdAt: string = '';
    public customTeamId: number | null = null;
    public customTeamName: string | null = null;
    public gameCount: number = 0;
    public id: number = 0;
    public internalId: number = 0;
    public name: string = '';
    public sportId: number = 0;
    public updatedAt: string = '';

    constructor(data?: ITeamPageApi) {
        super();

        if (!data) {
            return;
        }

        this.id = data.id;
        this.createdAt = data.created_at;
        this.updatedAt = data.updated_at;
        this.internalId = data.internal_id;
        this.name = data.name;
        this.sportId = data.sport_id;
        this.bookmakerId = data.site_id;
        this.customTeamId = data.custom_team_id;
        this.customTeamName = data.custom_team_name;
        this.gameCount = data.game_count;
    }

    get customTeamDisplay(): string {
        if (!this.hasCustomTeamAssociation) {
            return '';
        }

        if (this.customTeamName) {
            return `${this.customTeamName} (${this.customTeamId})`;
        }

        return String(this.customTeamId);
    }

    get hasCustomTeamAssociation(): boolean {
        return this.customTeamId != null;
    }
}
